<script lang="ts">
  let clazz: string = '';
  export { clazz as class };
</script>

<div class="mb-3 rounded bg-red-300 p-6 text-red-900 {clazz}">
  <slot />
</div>
